class RestaurantDetails extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
		this.prevent = false;
	}

	init() {
		this.addEvents();
	}

	addEvents() {
		Me.dispatch.subscribe('restaurant-toolbox', (e, params) => this.handleDisplay(e, params));
		Me.dispatch.subscribe('breakpointChanged', (e, params) => this.handleBreakpoints(e, params));
		this.$('.order-btn').on('click', (e) => this.trackOrder(e));
	}

	removeEvents() {

	}

	handleDisplay(e){
		this.$el.toggleClass('opened');

		$(window).on('mousedown', (e)=>this.closeHandler(e))
	}

	closeHandler(e){
		e.stopPropagation();

		let $target = $(e.target);
		if($target.parents('.restaurant-info-toolbox').length === 0 && this.$el.hasClass('opened') && $target.parents('.restaurant-modal-handler').length === 0){
			$(window).off('mousedown');
			this.$el.removeClass('opened');
			Me.dispatch.emit('restaurant-toolbox-closing', this);
		}

	}

	handleBreakpoints(e, params){
		this.prevent = (params.breakpoint !== '767-');
	} 

	trackOrder(e){
		Me.track.event("Restaurant", "Order", $(e.currentTarget).attr('href'));
		fbq('track', 'ViewContent');
	}
}